import * as LoginComponents from './Login';
import BaseButton from './BaseButton';
import * as InvertedButtonComponents from './InvertedButton';

// TODO: incorporate these into the web app
export const Button = BaseButton;
export const LastUsedTag = LoginComponents.LastUsedTag;
export const LoginButton = LoginComponents.LoginButton;

// new buttons
export const InvertedButton = InvertedButtonComponents.InvertedButton;
